import { BI_SCHEMA } from '../../utils/bi-logger/bi-events';
import { biLoggerActionCreator } from '../../utils/bi-logger/bi-logger';

export const sendAppLoadStartBiEvent = ({
  projectId,
  organizationId,
}: {
  projectId: string;
  organizationId: string;
}) => {
  const params = {
    projectId: projectId || '',
    organizationId: organizationId || '',
  };

  return biLoggerActionCreator({
    event: BI_SCHEMA.app.load.start,
    params,
  });
};

export const sendAppLoadFinishBiEvent = ({
  projectId,
  organizationId,
  loadingTime,
}: {
  projectId: string;
  organizationId: string;
  loadingTime: number;
}) => {
  const params = {
    loadingTime,
    projectId: projectId || '',
    organizationId: organizationId || '',
  };

  return biLoggerActionCreator({
    event: BI_SCHEMA.app.load.finish,
    params,
  });
};
